import type { WorkspacePulseSnapshot } from '../../services/aiAgentBridge'

export const pulseMetricStrip = (pulse: WorkspacePulseSnapshot) => [
  { id: 'risks', label: 'Open risks', value: pulse.openRiskCount },
  { id: 'automation', label: 'Automation fails', value: pulse.failedAutomationCount },
  { id: 'stock', label: 'Stock pressure', value: pulse.stockShortageCount },
  { id: 'budget', label: 'Budget', value: `${Math.round(pulse.budget.utilization * 100)}%` },
] as const

export type PulseMetricId = ReturnType<typeof pulseMetricStrip>[number]['id']
